import { render, staticRenderFns } from "./CustomFormWizard.vue?vue&type=template&id=2ea9dfda&"
import script from "./CustomFormWizard.vue?vue&type=script&lang=js&"
export * from "./CustomFormWizard.vue?vue&type=script&lang=js&"
import style0 from "./CustomFormWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports